import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SubItem = _resolveComponent("SubItem");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-container flex-box flex_d-column", {
      'has-opened-menu': _ctx.hasOpenedMenu
    }])
  }, [_createVNode(_component_el_scrollbar, {
    class: "flex-item_f-1"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_menu, {
      ref: "menuRef",
      "default-active": _ctx.active,
      "background-color": _ctx.theme.backgroundColor !== '#fff' ? _ctx.theme.backgroundColor : '',
      "text-color": _ctx.theme.textColor,
      "active-text-color": _ctx.theme.activeTextColor,
      "unique-opened": true,
      collapse: _ctx.collapse,
      onOpen: _ctx.handleMenuOpen,
      onClose: _ctx.handleMenuClose
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData, item => {
        return _openBlock(), _createBlock(_component_SubItem, {
          key: item.path,
          path: item.path,
          data: item
        }, null, 8, ["path", "data"]);
      }), 128))]),
      _: 1
    }, 8, ["default-active", "background-color", "text-color", "active-text-color", "collapse", "onOpen", "onClose"])]),
    _: 1
  })], 2);
}